import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "trayek-form" }
const _hoisted_2 = {
  class: "mx-5 py-5 flex gap-2",
  style: {"border-bottom":"1px solid #E2E8F0"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { class: "font-bold" }, "Informasi Trayek", -1)
const _hoisted_4 = { class: "p-5" }
const _hoisted_5 = { class: "invalid-feedback" }
const _hoisted_6 = { class: "invalid-feedback" }
const _hoisted_7 = { class: "invalid-feedback" }
const _hoisted_8 = { class: "flex items-center gap-3" }
const _hoisted_9 = { class: "w-1/3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "Min Liter", -1)
const _hoisted_11 = { class: "p-inputgroup flex-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Liter", -1)
const _hoisted_13 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_14 = {
  key: 1,
  class: "invalid-feedback"
}
const _hoisted_15 = { class: "w-1/3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "Rata-rata Liter", -1)
const _hoisted_17 = { class: "p-inputgroup flex-1" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Liter", -1)
const _hoisted_19 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_20 = { class: "w-1/3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "Max Liter", -1)
const _hoisted_22 = { class: "p-inputgroup flex-1" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Liter", -1)
const _hoisted_24 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_25 = { class: "flex w-full" }
const _hoisted_26 = { class: "w-1/2" }
const _hoisted_27 = { class: "invalid-feedback" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "px-3 flex items-center" }, " s/d ", -1)
const _hoisted_29 = { class: "w-1/2" }
const _hoisted_30 = { class: "invalid-feedback" }
const _hoisted_31 = { class: "flex flex-wrap gap-5" }
const _hoisted_32 = ["for"]
const _hoisted_33 = { class: "mb-4" }
const _hoisted_34 = { class: "mb-2 text-sm font-semibold" }
const _hoisted_35 = { class: "border-grey-2 p-4 rounded-lg" }
const _hoisted_36 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  key: 0,
  class: "invalid-feedback mt-5"
}
const _hoisted_39 = { class: "flex items-center justify-end gap-4 mt-4" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Kembali'), -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Selanjutnya'), -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvg = _resolveComponent("InlineSvg")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Field = _resolveComponent("Field")!
  const _component_RowInput = _resolveComponent("RowInput")!
  const _component_SelectFetch = _resolveComponent("SelectFetch")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_FieldArray = _resolveComponent("FieldArray")!
  const _component_CardCustom = _resolveComponent("CardCustom")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      onSubmit: _ctx.nextPage,
      "initial-values": _ctx.formValues,
      "validation-schema": _ctx.trayekType === 0 || _ctx.trayekType === 2 ? _ctx.schemaFormTrayek : _ctx.schemaFormTrayekReserve,
      validateOnMount: false
    }, {
      default: _withCtx(({ errors, values, setFieldValue, meta }) => [
        _createVNode(_component_CardCustom, null, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_InlineSvg, {
                src: require('@/assets/img/icon/stack-with-box.svg')
              }, null, 8, ["src"]),
              _hoisted_3
            ])
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_RowInput, {
                required: "",
                label: "Nama Trayek",
                "helper-text": "Masukkan nama trayek",
                class: "mb-5"
              }, {
                content: _withCtx(() => [
                  _createVNode(_component_Field, { name: "Name" }, {
                    default: _withCtx(({ field, handleChange, handleBlur }) => [
                      _createVNode(_component_InputText, _mergeProps(field, {
                        class: "w-full input-default",
                        type: "text",
                        placeholder: "Masukkan Nama Trayek",
                        maxlength: "50"
                      }), null, 16)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(errors.Name), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_RowInput, {
                required: "",
                label: "Kode Trayek",
                "helper-text": "Tuliskan kode trayek",
                class: "mb-5"
              }, {
                content: _withCtx(() => [
                  _createVNode(_component_Field, {
                    class: "w-full input-default",
                    type: "text",
                    name: "Code"
                  }, {
                    default: _withCtx(({ field, handleChange, handleBlur }) => [
                      _createVNode(_component_InputText, _mergeProps(field, {
                        id: "trayek-code",
                        class: "w-full input-default",
                        type: "text",
                        placeholder: "Masukkan Kode Trayek",
                        maxlength: "20",
                        onKeypress: _cache[0] || (_cache[0] = ($event: any) => (_ctx.disableSpace($event)))
                      }), null, 16)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(errors.Code), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_RowInput, {
                required: "",
                label: "Kelas",
                "helper-text": "Pilih kelas yang tersedia",
                class: "mb-5"
              }, {
                content: _withCtx(() => [
                  _createVNode(_component_Field, { name: "Class" }, {
                    default: _withCtx(({ field, handleChange, handleBlur }) => [
                      _createVNode(_component_SelectFetch, _mergeProps(field, {
                        modelValue: field.value,
                        inputId: "class-input",
                        endpoint: "/management/v1/MsClass",
                        fieldLabel: (v) => v.Name,
                        clearable: false,
                        searchFields: ['name'],
                        placeholder: `Pilih Kelas`,
                        classname: 'custom-select'
                      }), null, 16, ["modelValue", "fieldLabel"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(errors.Class), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_RowInput, {
                required: "",
                label: "Perkiraan Liter per-PP",
                "helper-text": "Perkiraan jumlah BBM yang dihabiskan dalam 1x PP",
                class: "mb-5"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createVNode(_component_Field, { name: "Class" }, {
                        default: _withCtx(({ field, handleChange, handleBlur }) => [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_InputNumber, {
                              modelValue: values.MinimumFuelConsumptionLiters,
                              "onUpdate:modelValue": ($event: any) => ((values.MinimumFuelConsumptionLiters) = $event),
                              class: _normalizeClass(`${errors.MinimumFuelConsumptionLiters ? 'input-invalid' : ''}`),
                              id: "MinimumFuelConsumptionLiters",
                              placeholder: "0",
                              min: 0,
                              locale: "id-ID",
                              step: 0.25,
                              minFractionDigits: 2,
                              maxFractionDigits: 2,
                              inputId: "refund-amount"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "step"]),
                            _hoisted_12
                          ])
                        ]),
                        _: 2
                      }, 1024),
                      (meta.touched)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(errors.MinimumFuelConsumptionLiters), 1))
                        : _createCommentVNode("", true),
                      (meta.touched)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(errors.MinLiters), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_Field, { name: "Class" }, {
                        default: _withCtx(({ field, handleChange, handleBlur }) => [
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_InputNumber, {
                              modelValue: values.EstimatedFuelConsumptionLiters,
                              "onUpdate:modelValue": ($event: any) => ((values.EstimatedFuelConsumptionLiters) = $event),
                              class: _normalizeClass(`${errors.EstimatedFuelConsumptionLiters ? 'input-invalid' : ''}`),
                              id: "EstimatedFuelConsumptionLiters",
                              placeholder: "0",
                              min: 0,
                              locale: "id-ID",
                              step: 0.25,
                              minFractionDigits: 2,
                              maxFractionDigits: 2,
                              inputId: "refund-amount"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "step"]),
                            _hoisted_18
                          ])
                        ]),
                        _: 2
                      }, 1024),
                      (meta.touched)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(errors.EstimatedFuelConsumptionLiters), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createVNode(_component_Field, { name: "Class" }, {
                        default: _withCtx(({ field, handleChange, handleBlur }) => [
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_InputNumber, {
                              modelValue: values.MaximumFuelConsumptionLiters,
                              "onUpdate:modelValue": ($event: any) => ((values.MaximumFuelConsumptionLiters) = $event),
                              class: _normalizeClass(`${errors.MaximumFuelConsumptionLiters ? 'input-invalid' : ''}`),
                              id: "MaximumFuelConsumptionLiters",
                              placeholder: "0",
                              min: 0,
                              locale: "id-ID",
                              step: 0.25,
                              minFractionDigits: 2,
                              maxFractionDigits: 2,
                              inputId: "refund-amount"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "step"]),
                            _hoisted_23
                          ])
                        ]),
                        _: 2
                      }, 1024),
                      (meta.touched)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(errors.MaximumFuelConsumptionLiters), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_RowInput, {
                required: "",
                label: "Tanggal Berlaku SKIT",
                "helper-text": "Tanggal berlaku merupakan tanggal masa aktif trayek yang sudah dibuat",
                class: "mb-5"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_Field, { name: "StartDate" }, {
                        default: _withCtx(({ field, handleChange, handleBlur }) => [
                          _createVNode(_component_DatePicker, _mergeProps(field, {
                            masks: {
                        input: 'DD/MM/YYYY'
                      },
                            maxDate: values.EndDate ? new Date(new Date(values.EndDate).setDate(new Date(values.EndDate).getDate() - 1)) : null
                          }), {
                            default: _withCtx(({ togglePopover }) => [
                              _createVNode(_component_InputText, {
                                id: "start-date",
                                placeholder: "Masukkan tanggal mulai",
                                readonly: true,
                                value: values.StartDate ? `${_ctx.moment(values.StartDate.toString()).format('DD/MM/YYYY')}` : values.StartDate,
                                class: _normalizeClass(`input-default`),
                                onClick: togglePopover
                              }, null, 8, ["value", "onClick"])
                            ]),
                            _: 2
                          }, 1040, ["maxDate"])
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("div", _hoisted_27, _toDisplayString(errors.StartDate), 1)
                    ]),
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_Field, { name: "EndDate" }, {
                        default: _withCtx(({ field, handleChange, handleBlur }) => [
                          _createVNode(_component_DatePicker, _mergeProps(field, {
                            masks: {
                        input: 'DD/MM/YYYY'
                      },
                            minDate: new Date(new Date(values.StartDate).setDate(new Date(values.StartDate).getDate() + 1))
                          }), {
                            default: _withCtx(({ togglePopover }) => [
                              _createVNode(_component_InputText, {
                                id: "end-date",
                                placeholder: "Masukkan tanggal akhir",
                                readonly: true,
                                value: values.EndDate ? `${_ctx.moment(values.EndDate.toString()).format('DD/MM/YYYY')}` : values.EndDate,
                                class: _normalizeClass(`input-default`),
                                onClick: togglePopover,
                                disabled: !values.StartDate
                              }, null, 8, ["value", "onClick", "disabled"])
                            ]),
                            _: 2
                          }, 1040, ["minDate"])
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("div", _hoisted_30, _toDisplayString(errors.EndDate), 1)
                    ])
                  ])
                ]),
                _: 2
              }, 1024),
              (_ctx.trayekType !== 1)
                ? (_openBlock(), _createBlock(_component_RowInput, {
                    key: 0,
                    required: "",
                    label: "Tol/Non Tol",
                    class: "mb-5"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_31, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList([true, false], (tl, idx) => {
                          return _createElementVNode("div", {
                            class: "flex items-center",
                            key: idx
                          }, [
                            _createVNode(_component_RadioButton, {
                              modelValue: _ctx.isTol,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isTol) = $event)),
                              inputId: `tol-${idx}`,
                              name: "tol",
                              value: tl
                            }, null, 8, ["modelValue", "inputId", "value"]),
                            _createElementVNode("label", {
                              for: `tol-${idx}`,
                              class: "ml-2"
                            }, _toDisplayString(tl ? 'Tol' : 'Non Tol'), 9, _hoisted_32)
                          ])
                        }), 64))
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.trayekType !== 1)
                ? (_openBlock(), _createBlock(_component_RowInput, {
                    key: 1,
                    required: "",
                    label: "RIT",
                    "helper-text": "Masukkan Rit salah satu dari 2 rit yang tersedia",
                    class: "mb-5"
                  }, {
                    content: _withCtx(() => [
                      _createVNode(_component_FieldArray, { name: "Rits" }, {
                        default: _withCtx(({ fields, push, remove }) => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields, (data, index) => {
                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, _toDisplayString(`RIT ${index + 1}`), 1),
                                _createElementVNode("div", _hoisted_35, [
                                  _createElementVNode("div", _hoisted_36, [
                                    _createVNode(_component_Field, {
                                      name: `Rits[${index}].rit`
                                    }, {
                                      default: _withCtx(({ field, handleChange, handleBlur }) => [
                                        _createVNode(_component_SelectFetch, _mergeProps(field, {
                                          modelValue: field.value,
                                          inputId: `rit-${index}`,
                                          endpoint: "/management/v1/MsRoute",
                                          fieldLabel: (v) => v.Name,
                                          searchCustom: [['activeOnly', '=', true]],
                                          selectable: (v) => v.HasPrice === true,
                                          clearable: false,
                                          searchFields: ['name'],
                                          "onUpdate:modelValue": _ctx.onChange,
                                          placeholder: `Pilih Rit ${index + 1}`,
                                          classname: 'custom-select'
                                        }), null, 16, ["modelValue", "inputId", "fieldLabel", "selectable", "onUpdate:modelValue", "placeholder"])
                                      ]),
                                      _: 2
                                    }, 1032, ["name"]),
                                    (values.Rits[index].rit)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                          _createVNode(_component_Field, {
                                            name: `Rits[${index}].expense`
                                          }, {
                                            default: _withCtx(({ field, handleChange, handleBlur }) => [
                                              _createVNode(_component_SelectFetch, _mergeProps(field, {
                                                modelValue: field.value,
                                                inputId: `expense-${index}`,
                                                endpoint: "/management/v1/MsExpenses",
                                                fieldLabel: (v) => v.Name,
                                                clearable: false,
                                                searchFields: ['name'],
                                                "onUpdate:modelValue": _ctx.onChange,
                                                placeholder: `Pilih Pengeluaran Rit ${index + 1}`,
                                                classname: 'custom-select'
                                              }), null, 16, ["modelValue", "inputId", "fieldLabel", "onUpdate:modelValue", "placeholder"])
                                            ]),
                                            _: 2
                                          }, 1032, ["name"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ])
                            ]))
                          }), 128)),
                          (meta.touched && !meta.valid)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(errors.Rits), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 2
        }, 1024),
        _createElementVNode("div", _hoisted_39, [
          _createVNode(_component_Button, {
            class: "flex gap-2 extra-submit-button",
            outlined: true,
            onClick: _ctx.prevPage
          }, {
            default: _withCtx(() => [
              _hoisted_40
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_Button, {
            type: "submit",
            class: "mb-2 sm:mb-0 flex gap-2"
          }, {
            default: _withCtx(() => [
              _hoisted_41
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "initial-values", "validation-schema"])
  ]))
}